function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 1c-.555 0-1 .445-1 1v4c0 .555.445 1 1 1h4c.555 0 1-.445 1-1V2c0-.555-.445-1-1-1zm8 0c-.555 0-1 .445-1 1v4c0 .555.445 1 1 1h4c.555 0 1-.445 1-1V2c0-.555-.445-1-1-1zM2 9c-.555 0-1 .445-1 1v4c0 .555.445 1 1 1h4c.555 0 1-.445 1-1v-4c0-.555-.445-1-1-1zm8 0c-.555 0-1 .445-1 1v4c0 .555.445 1 1 1h4c.555 0 1-.445 1-1v-4c0-.555-.445-1-1-1zm0 0"
});

var SvgLayout = function SvgLayout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 16 16",
    fill: "#18191F"
  }, props), _ref);
};

export default SvgLayout;